import Auth from "@/utils/auth";

const initializeHomePage = async (track_id: any) => {
  const auth = new Auth(track_id);
  await auth.init();
};

export default initializeHomePage;
